import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';

import '../InformView.css';
import './ManagerialCrossInformView.css';
import { apiUrl } from '../../../utility/Connections';
import ManagerialCrossGeneral from '../../../components/informs/managerialCrossGeneral/managerialCrossGeneral';

const ManagerialCrossInformView = () => {
    const { gcr_id } = useParams();

    const [showLoading, setShowLoading] = useState(true);
    const [reportData, setReportData] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null);

    useEffect(() => {
        getManagerialReport(gcr_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gcr_id]);

    const getManagerialReport = (runId) => {
        setShowLoading(true);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/informs/get-managerial-cross-report/${runId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setReportData(data);
                const orgId = data?.org_id || data?.payload?.evaluations?.ipra?.org_id || data?.payload?.evaluations?.iash?.org_id;
                if (orgId) {
                    getOrganizationLogo(orgId);
                } else {
                    setShowLoading(false);
                }
            })
            .catch(function () {
                setShowLoading(false);
                setReportData(null);
            });
    };

    const getOrganizationLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function () {
                setShowLoading(false);
            });
    };

    if (showLoading) {
        return (
            <div className="display-center-row display-center-column align-full-center managerial-cross-loading">
                <Spin size="large" tip="Cargando informe gerencial..." />
            </div>
        );
    }

    if (!reportData) {
        return <div>Error al cargar la información del informe gerencial.</div>;
    }

    return (
        <div className="informe-wrapper managerial-cross-view-wrapper">
            <ManagerialCrossGeneral reportData={reportData} orgLogo={orgLogo} orgName={reportData?.org_name} />
        </div>
    );
};

export default ManagerialCrossInformView;
